import styled from "styled-components";
import { palette, size } from "styled-theme";

const Wrapper = styled.div`
  .textBox {
    display: flex;
    margin: 10px 0px;
    height: 80px;
    flex-direction: column;
    position: relative;
  }
  .textBox-Label-Container {
    display: flex;
    width: fit-content;
  }
  .textBox-Label {
    display: inline-flex;
    padding-left: 3px;
    padding-bottom: 7px;
    color: ${palette("formInputElement", 0)};
    font-weight: 400;
    font-size: ${size("p0")};

    &.error {
      color: ${palette("error", 4)};
      font-weight: bold;
    }
  }
  .textBox-Label-Optional {
    padding-left: 6px;
    font-size: ${size("p3")};
    color: ${palette("grayscale", 15)};
    font-weight: 400;
  }
  .textBox-Input {
    display: flex;
    border: 1px solid ${palette("formInputElement", 1)};
    border-radius: 5px;
    height: 36px;
    margin: 0 !important;
    overflow: hidden;
    background-color:${palette("formInputElement", 5)};
  }
  .textBox-Icon {
    color: ${palette("formInputElement", 7)};
    border-right: 1px solid ${palette("formInputElement", 7)};
    margin-right: 7px;
    min-width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .textBox-Icon-Suffix {
    color: ${palette("formInputElement", 1)};
    border-left: 1px solid ${palette("formInputElement", 1)};
    margin-left: 7px;
    min-width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .textBox-Icon * {
    display: inherit;
    font-size: ${size("p0")};
  }
  .textBox-Input input {
    display: inline-block;
    border: none;
    align-content: center;
    width: 100%;
    font-size: ${size("p0")};
    padding: none !important;
    color:${palette("formInputElement", 8)};
    text-overflow: ellipsis;
    padding-left: 10px;
    line-height: 36px;
  }
  .textBox-Input input:focus {
    outline: none;
  }
  .required:focus-within {
    box-shadow: 0 0 6px ${palette("color", 18)};
    outline: none;
  }
  .textBox-Input:focus-within:not(.required) {
    box-shadow: 0 0 6px ${palette("input", 0)};
  }
  .required {
    border: 2px solid ${palette("error", 3)}!important;
  }
  .iconRequired {
    border-right: 1px solid ${palette("error", 4)};
    color: ${palette("error", 3)};
  }
  .textBox-Input input::placeholder {
    color: ${palette("formInputElement", 2)};
    font-weight: lighter;
  }

  .textBox.incomeField .validation-message{
    top: 80px;
    margin-top: 5px;
  }
  .textBox.residentialPayment {
    padding-bottom: 15px;
  }
  .textBox.incomeField {
    justify-content: flex-end;
  }

`;

export default Wrapper;
